import BaseModel from '../../base';

export default class RatingEventDirection extends BaseModel {
  constructor(item = {}, url = '') {
    super(item, url);
  }
}
